import React from 'react';
import { Link } from 'react-router';

const PrivacyPolicy = () => {
    return (
        <div id="privacy-policy" className="min-h-screen bg-[#e3daed] py-12 sm:py-16 lg:py-20">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
                {/* Header */}
                <div className="text-center mb-12 lg:mb-16">
                    <h1 className="font-cormorant font-semibold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-gray-900 mb-4">
                        Privacy Policy
                    </h1>
                    <p className="font-nunito text-sm sm:text-base text-gray-600">
                        Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </p>
                </div>

                {/* Content */}
                <div className="space-y-8 sm:space-y-10">
                    <section>
                        <h2 className="font-cormorant font-semibold text-2xl sm:text-3xl lg:text-4xl text-gray-900 mb-4">
                            Your Privacy is Protected
                        </h2>
                        <p className="font-nunito text-base sm:text-lg text-gray-700 leading-relaxed">
                            All information shared during our therapeutic sessions is held in strict confidence. As your therapist, I am committed to maintaining the highest standards of privacy and confidentiality to create a safe, trusting environment for your healing journey.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-cormorant font-semibold text-2xl sm:text-3xl lg:text-4xl text-gray-900 mb-4">
                            What This Means for You
                        </h2>
                        <ul className="font-nunito text-base sm:text-lg text-gray-700 leading-relaxed space-y-3 list-disc list-inside pl-4">
                            <li><span className="font-semibold">Complete Confidentiality:</span> Everything you discuss in therapy stays between us.</li>
                            <li><span className="font-semibold">No Information Sharing:</span> Your personal details, session content, and identifying information will never be shared with anyone without your explicit written consent.</li>
                            <li><span className="font-semibold">Secure Records:</span> All client records are maintained according to professional standards and legal requirements.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="font-cormorant font-semibold text-2xl sm:text-3xl lg:text-4xl text-gray-900 mb-4">
                            Limited Exceptions
                        </h2>
                        <p className="font-nunito text-base sm:text-lg text-gray-700 leading-relaxed mb-4">
                            Confidentiality can only be broken in specific circumstances required by law:
                        </p>
                        <ul className="font-nunito text-base sm:text-lg text-gray-700 leading-relaxed space-y-3 list-disc list-inside pl-4">
                            <li><span className="font-semibold">Imminent Risk of Harm:</span> If there is a clear and immediate danger to yourself or others.</li>
                            <li><span className="font-semibold">Emergency Situations:</span> When immediate intervention is necessary to ensure safety.</li>
                            <li><span className="font-semibold">Legal Requirements:</span> As mandated by state and federal regulations.</li>
                        </ul>
                         <p className="font-nunito text-base sm:text-lg text-gray-700 leading-relaxed mt-4">
                            In such rare cases, only the minimum necessary information would be shared with appropriate emergency contacts or authorities to ensure safety.
                        </p>
                    </section>

                    <section>
                        <h2 className="font-cormorant font-semibold text-2xl sm:text-3xl lg:text-4xl text-gray-900 mb-4">
                            Your Rights
                        </h2>
                        <p className="font-nunito text-base sm:text-lg text-gray-700 leading-relaxed">
                            You have the right to understand how your information is used and protected. During our first session, we'll discuss these policies in detail and address any questions you may have about confidentiality.
                        </p>
                    </section>
                    
                    <section>
                        <p className="font-nunito text-base sm:text-lg text-gray-700 leading-relaxed italic">
                            Your trust is the foundation of effective therapy, and protecting your privacy is my professional and ethical responsibility.
                        </p>
                    </section>
                </div>

                {/* Back to Home Button */}
                <div className="mt-12 sm:mt-16 text-center">
                    <Link
                        to="/"
                        className="font-nunito text-base sm:text-lg text-gray-600 hover:text-gray-900 underline underline-offset-4 transition-colors"
                    >
                        Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy; 